import React from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';
import { Promise } from 'es6-promise';

import Form from '../Common/Form.react';
import TextField from '../Common/TextField';
import SelectField from '../Common/SelectField';
import { Card, CardText } from 'material-ui/Card';
import MenuItem from 'material-ui/MenuItem';
import LinearProgress from 'material-ui/LinearProgress';
import FileUpload from '../Common/FormsyFileUpload';
import Toggle from 'material-ui/Toggle';

import AssetActions from '../../actions/AssetActionCreator';
import AssetStore from '../../stores/AssetStore';
import AssetTypeStore from '../../stores/AssetTypeStore';

import AssetWysiwygEditor from './AssetWysiwygEditor';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Checkbox from 'material-ui/Checkbox';
import TextFieldMaterial from 'material-ui/TextField';
import update from 'immutability-helper';
import { withId } from '../Common/Decorators';

const AssetForm = React.createClass({

    getInitialState: function() {

        return {
            isEdit: !!this.props.id,
            details: {
                id: undefined,
                name: '',
                typeId: undefined,
                asAttachment: undefined,
                content: '',
                assetFile: undefined,
                versionable: false
            },
            types: [],
            progress: 0,
            isDialogOpen: false,
            copy: false,
            versionName: '',
            dialogFormData: {},
            rawHTML: true,
            embeddedImageName: '',
            embeddedImages: [],
            suppressFormRedirect: false,
            suppressSuccessMessage: false,
            formSubmitted: false
        };
    },

    componentDidMount: function() {
        this.listeners = [
            AssetTypeStore.addListener(this._onTypeChange),
            AssetStore.addListener(this._onAssetChange),
        ];
        AssetActions.getTypes();

        if (this.state.isEdit) {
            AssetActions.getById(this.props.id);
        }
    },

    componentWillUnmount: function() {
        this.listeners.forEach(listener => listener.remove());

        if (!this.state.formSubmitted) {
            this.state.embeddedImages.forEach((id) => {AssetActions.delete(id);});
        }
    },

    render: function() {
        let formElements = [];

        if (!!this.state.details.typeId) {
            if (!this.state.details.asAttachment) {
                // content editor
                if (!!this.state.rawHTML) {
                    formElements.push(
                        <TextField
                            key="content"
                            name="content"
                            value={this.state.details.content}
                            floatingLabelText="Content"
                            onChange={this._handleTextFieldChange}
                            multiLine={true}
                            rowsMax={40}
                        />
                    );
                } else {
                    formElements.push(
                        <AssetWysiwygEditor
                            value={this.state.details.content}
                            onChange={this._handleContentChange}
                            editorProps={{
                                key:         'content',
                                name:        'content',
                                placeholder: 'Content'
                            }}
                            uploadCallback={this.onWysiwygImageUpload}
                        />
                    );
                }
                formElements.push(<Toggle label="Edit raw HTML" labelPosition="right" toggled={this.state.rawHTML} onToggle={this.onToggle} />);
            } else if (!this.state.isEdit || !!this.state.details.versionable) { // if !!this.state.details.asAttachment
                // file browser
                const type = this.state.types.find(type => (type !== undefined && type.id === this.state.details.typeId));
                if (!!type) {
                    formElements.push(
                        <FileUpload
                            key="asset"
                            name="asset"
                            onChange={this._handleFileBrowse}
                            allowedMimeTypes={type.allowedMimeTypes}
                            errorMessage="Invalid file type!"
                            required
                        />
                    );
                }
            }
        }

        let dialog;
        if (!!this.state.isEdit && !!this.state.isDialogOpen) {
            const versionField = (!!this.state.copy)  && (
                    <TextFieldMaterial
                        value={this.state.versionName}
                        onChange={(event) => this._handleOnVersionChange(event, this)}
                        floatingLabelText="Version name"
                    />
                );

            dialog = (
                <Dialog
                    title="Save Asset"
                    open={this.state.isDialogOpen}
                    actions={[<FlatButton key={0} label="Save" onTouchTap={() => this._handleOnDialogSubmit(this)} />]}
                    autoScrollBodyContent={true}
                >
                    <Checkbox
                        label="Archive previous version"
                        checked={this.state.copy}
                        onCheck={() => this._handleOnCopyCheck(this)}
                    />
                    {(!!this.state.copy) && (
                        <TextFieldMaterial
                            value={this.state.versionName}
                            onChange={(event) => this._handleOnVersionChange(event, this)}
                            floatingLabelText="Version name"
                        />
                    )}
                </Dialog>
            );
        }
        return (
            <div>
                <Form
                    title={(this.state.isEdit ? 'Edit' : this.props.title)}
                    onSave={this._onSubmit}
                    onCancel={this._onCancel}
                    redirectTo={this.props.returnUrl}
                    onError={this._onError}
                    suppressRedirect={this.state.suppressFormRedirect}
                    suppressSuccessMessage={this.state.suppressSuccessMessage}
                >
                    <Card className="cent-card">
                        <CardText>
                            {!this.state.isEdit && (
                                <SelectField
                                    name="typeId"
                                    value={this.state.details.typeId}
                                    floatingLabelText="Type"
                                    onChange={this._handleTypeChange}
                                    required
                                >
                                    {this.state.types.map(({id, name}) => <MenuItem key={id} value={id} primaryText={name} />)}
                                </SelectField>
                            )}
                            <TextField
                                name="name"
                                value={this.state.details.name}
                                floatingLabelText="Name"
                                onChange={this._handleTextFieldChange}
                                required
                            />
                            {formElements}
                            {(this.state.progress > 0 ||(this.state.isEdit && !this.state.details.id)) && (<LinearProgress key="loading" mode="indeterminate" />)}
                        </CardText>
                    </Card>
                </Form>
                {dialog}
            </div>
        );
    },

    _handleOnDialogSubmit: (that) => {
        const {state} = that;
        that.setState(assign({}, state, {isDialogOpen: false}));
        that._onSubmit = that._onSubmit.bind(that);
        that._onSubmit(state.dialogFormData, true);
    },
    _handleOnCopyCheck: (that) => {
        const {state} = that;
        that.setState(assign({}, state, {copy: !state.copy}));
    },
    _handleOnVersionChange: (event, that) => {
        const {state} = that;
        that.setState(assign({}, state, {versionName: event.target.value}));
    },
    // Field events
    _handleTypeChange: function(event, value, index) {
        const type = this.state.types.find(function(e) { return e !== undefined && e.id === value; });
        const details = Object.assign({}, this.state.details, {typeId: value, asAttachment: !!type.asAttachment });
        let state = Object.assign({}, this.state, {details});
        if (!details.content) { state.rawHTML = !!type.asAttachment; }
        this.setState(state);
    },

    _handleTextFieldChange: function(event) {
        if (this.state.details.hasOwnProperty(event.target.name)) {
            let state = this.state;
            state.details[event.target.name] = event.target.value;
            this.setState(state);
        }
    },
    _handleContentChange: function(content) {
        const newDetails = assign({}, this.state.details, {content: content});
        this.setState(assign({}, this.state, {details: newDetails}));
    },
    _handleFileBrowse: function(name, file, value) {
        const state = update(this.state, { details: { assetFile: { $set: file } } } );
        this.setState(state);
    },
    onToggle: function({target}, toggled) {
        this.setState({rawHTML: toggled});
    },
    // Form events
    _onAssetChange: function() {
        let asset = AssetStore.getById(this.props.id);
        if (asset !== undefined) {
            let state = assign({}, this.state, {details: asset, rawHTML: !!asset.asAttachment});
            this.setState(state);
        }
    },

    _onTypeChange: function() {
        let types = AssetTypeStore.getAll();
        if (types !== undefined) {
            let state = assign({}, this.state, {types: types});
            this.setState(state);
        }
    },
    _onCancel: function() {
        if (this.props.onCancel) {
            return this.props.onCancel(this.state.asset, this.props.returnUrl);
        }

        window.location.href = this.props.returnUrl;
    },

    _onSubmit: function(formData, formDialog) {
        this.setState({formSubmitted: true, suppressFormRedirect: false, suppressSuccessMessage: false});

        if (!formDialog && this.state.isEdit) {
            if (!!this.state.details.versionable) {
                return this.setState(assign({}, this.state, {isDialogOpen: true, dialogFormData: formData}));
            }
        }
        // upload files
        if (!formData.content) {
            formData.content = this.state.details.content;
        }
        if (!!this.state.details.assetFile) {
            if (this.state.progress > 0) return false; // do not upload if it's in progress
            let files = [];
            files.push(this.state.details.assetFile);
            this.setState({progress: 1});
            return AssetActions.upload(files);
        }
        if (this.state.isEdit) {
            formData.copy = this.state.copy;
            formData.versionName = this.state.versionName;
            return this.props.onSubmitEdit(this.props.id, formData);
        }
        return this.props.onSubmit(formData);
    },

    _onError: function() {
        this.setState({progress: 0});
    },

    onWysiwygImageUpload: function(file) {
        return new Promise( (resolve, reject) => {
            AssetActions.upload([file]);

            // additional asset listener created to return required Promise to AssetWysiwygEditor resolving image link
            const listener = AssetStore.addListener(() => {
                const images = AssetStore.getByName(this.state.embeddedImageName);
                if (images.length === 1) {
                    let embeddedImages = this.state.embeddedImages;
                    embeddedImages.push(images[0].id);
                    this.setState({embeddedImages});
                    resolve({data: {link: images[0].link}});
                } else {
                    reject({error: true, message: 'Upload failed', data: null});
                }
                listener.remove();
            });
        });
    }
});

AssetForm.propTypes = {
    title: PropTypes.string,
    returnUrl: PropTypes.string,
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
    onSubmitEdit: PropTypes.func
};

AssetForm.defaultProps = {
    title: 'New Asset',
    returnUrl: '/dashboard/assets',
    onSubmit: AssetActions.save,
    onSubmitEdit: AssetActions.update
};

export default withId(AssetForm);
